import React from "react";
import { Route, Switch } from "react-router-dom";

import RTL from "../containers/RTL";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import SignInSide from "../components/SignIn/SignIn";
import Signup from "../components/Signup/Signup";
import Home from "../components/home";
import AuthContext from "../context/auth-context";
import Splash from "../components/Splash/splash";
import NotFound from "./../components/404";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function App() {
  const [authenticated, setAuthenticated] = React.useState(false);
  const [showSnackBar, setShowSnackBar] = React.useState(false);
  const [message, setMessage] = React.useState('');
  const [messageType, setMessageType] = React.useState('success');

  React.useEffect(() => {
    const loggedInUser = localStorage.getItem("user");
    if (loggedInUser) {
      // const foundUser = JSON.parse(loggedInUser);
      setAuthenticated(true);
    }
  }, []);
  const loginHandler = (user) => {
    localStorage.setItem("user", JSON.stringify(user));
    setAuthenticated(true);
  };
  const logoutHandler = () => {
    setAuthenticated(false);
    localStorage.clear();
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowSnackBar(false);
  };
  const showSnackBarHandler = status => {
    setShowSnackBar(status);
  }
  const messageHandler = message => {
    setMessage(message);
  }
  const messageTypeHandler = type => {
    setMessageType(type);
  }
  return (
    <RTL>
      <Snackbar open={showSnackBar} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={messageType}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
      <AuthContext.Provider
        value={{
          authenticated: authenticated,
          login: loginHandler,
          logout: logoutHandler,
          showSnackBar: showSnackBarHandler,
          message: messageHandler,
          messageType: messageTypeHandler
        }}
      >
        {authenticated ? (
          <Switch>
            <Route path="/" exact component={Home} />
            <Route component={NotFound} />
          </Switch>
        ) : (
          <Switch>
            <Route path="/login" exact component={SignInSide} />
            <Route path="/signup" exact component={Signup} />
            <Route path="/" exact component={Splash} />
            <Route component={NotFound} />
          </Switch>
        )}
      </AuthContext.Provider>
    </RTL>
  );
}

export default App;
